<template>
  <div id="contact-info">
    <h4 class="sub-title">Contact Information</h4>
    <div class="mobile_1 mt-4">
      <label for="mobile_2">Mobile Number:</label>
      <b-form-input
        v-validate="mobileValidation"
        @keyup.enter="emitValue(!required)"
        type="tel"
        name="mobile_1"
        v-model="mobile_1"
      ></b-form-input>
      <p v-if="errors.has('mobile_1')">{{ errors.first('mobile_1') }}</p>
    </div>
    <div class="mobile_2 mt-4">
      <label for="mobile_2">Mobile Number:</label>
      <b-form-input
        v-validate="mobileValidation"
        @keyup.enter="emitValue(!required)"
        type="tel"
        name="mobile_2"
        v-model="mobile_2"
      ></b-form-input>
      <p v-if="errors.has('mobile_2')">{{ errors.first('mobile_2') }}</p>
    </div>
    <div class="email mt-4">
      <label for="email">Email Address:</label>
      <b-form-input
        type="email"
        v-model="email"
        v-validate="'required|email'"
        :class="{ input: true, 'is-danger': errors.has('email') }"
        name="email"
      ></b-form-input>
      <p v-if="errors.has('email')" class="help is-danger">
        {{ errors.first('email') }}
      </p>
    </div>
    <br />
  </div>
</template>

<script>
export default {
  name: 'ContactInfo',
  props: {
    singular: String,
    plural: String,
  },
  data() {
    return {
      mobileValidation: 'numeric|min:9|max:10',
    };
  },
  computed: {
    mobile_1: {
      get() {
        return this.$store.state[this.plural][this.singular].mobile_1;
      },
      set(val) {
        this.$store.commit(`${this.plural}/mobile_1`, val);
      },
    },
    mobile_2: {
      get() {
        return this.$store.state[this.plural][this.singular].mobile_2;
      },
      set(val) {
        this.$store.commit(`${this.plural}/mobile_2`, val);
      },
    },
    email: {
      get() {
        return this.$store.state[this.plural][this.singular].email;
      },
      set(val) {
        this.$store.commit(`${this.plural}/email`, val);
      },
    },
  },
};
</script>
